export const allReviews = [
  {
    id: 1,
    name: "Sophie M.",
    location: "Paris 15e",
    type: "Appartement 3 pièces",
    service: "DPE",
    rating: 5,
    date: "Mars 2025",
    text: "Intervention rapide et professionnelle pour mon DPE avant vente. Le diagnostiqueur est arrivé à l'heure, a tout expliqué clairement et j'ai reçu mon rapport le soir même. Je recommande vivement Up Diag !",
    avatar: "/img/readdy/rv1.jpg",
  },
  {
    id: 2,
    name: "Thomas B.",
    location: "Boulogne-Billancourt (92)",
    type: "Maison 5 pièces",
    service: "Pack Vente",
    rating: 5,
    date: "Février 2025",
    text: "Pack vente complet réalisé en une seule visite. Très efficace, tarif transparent annoncé dès le devis. Le rapport était parfaitement rédigé pour mon notaire. Merci à toute l'équipe !",
    avatar: "/img/readdy/rv2.jpg",
  },
  {
    id: 3,
    name: "Marie-Claire D.",
    location: "Vincennes (94)",
    type: "Studio en location",
    service: "Pack Location",
    rating: 5,
    date: "Janvier 2025",
    text: "J'avais besoin d'un DPE et d'un diagnostic plomb en urgence pour ma mise en location. Up Diag a pu intervenir le lendemain matin. Service impeccable, je ferai appel à eux pour mes prochains biens.",
    avatar: "/img/readdy/rv3.jpg",
  },
  {
    id: 4,
    name: "Laurent P.",
    location: "Paris 8e",
    type: "Appartement 4 pièces",
    service: "DPE",
    rating: 5,
    date: "Janvier 2025",
    text: "Excellent service du début à la fin. Le diagnostiqueur a pris le temps d'expliquer les résultats et les recommandations de travaux. Rapport très détaillé, parfait pour la vente.",
    avatar: "/img/readdy/rv4.jpg",
  },
  {
    id: 5,
    name: "Isabelle R.",
    location: "Neuilly-sur-Seine (92)",
    type: "Appartement 2 pièces",
    service: "Amiante",
    rating: 5,
    date: "Décembre 2024",
    text: "Diagnostic amiante réalisé pour un appartement des années 70. Très professionnel, rapport clair et détaillé. Aucune amiante détectée, ce qui a rassuré l'acheteur. Parfait !",
    avatar: "/img/readdy/rv5.jpg",
  },
  {
    id: 6,
    name: "Frédéric G.",
    location: "Montreuil (93)",
    type: "Maison 4 pièces",
    service: "Pack Vente",
    rating: 5,
    date: "Décembre 2024",
    text: "Très satisfait du pack vente. Tout a été fait en 2h30, rapport reçu le soir même. Le prix était exactement celui annoncé dans le devis. Je recommande sans hésitation.",
    avatar: "/img/readdy/rv6.jpg",
  },
  {
    id: 7,
    name: "Nathalie V.",
    location: "Paris 11e",
    type: "Appartement 3 pièces",
    service: "Électricité",
    rating: 5,
    date: "Novembre 2024",
    text: "Diagnostic électricité pour un appartement haussmannien. Le diagnostiqueur a été très minutieux et a bien expliqué les anomalies détectées. Rapport très complet.",
    avatar: "/img/readdy/rv7.jpg",
  },
  {
    id: 8,
    name: "Pierre-Antoine L.",
    location: "Versailles (78)",
    type: "Maison 6 pièces",
    service: "Pack Vente",
    rating: 5,
    date: "Novembre 2024",
    text: "Intervention à Versailles pour un pack vente complet. Ponctuel, professionnel, rapport reçu le soir même. Notaire très satisfait de la qualité des documents. Merci !",
    avatar: "/img/readdy/rv8.jpg",
  },
  {
    id: 9,
    name: "Céline M.",
    location: "Créteil (94)",
    type: "Appartement T2",
    service: "DPE",
    rating: 4,
    date: "Octobre 2024",
    text: "Très bon service, diagnostiqueur compétent et sympathique. Rapport reçu rapidement. Petit bémol sur le délai de réponse initial mais une fois le RDV pris, tout s'est très bien passé.",
    avatar: "/img/readdy/rv9.jpg",
  },
  {
    id: 10,
    name: "Alain D.",
    location: "Saint-Denis (93)",
    type: "Local commercial",
    service: "Amiante",
    rating: 5,
    date: "Octobre 2024",
    text: "Diagnostic amiante pour un local commercial avant travaux. Très professionnel, rapport détaillé avec cartographie précise. Indispensable avant de lancer les travaux de rénovation.",
    avatar: "/img/readdy/rv10.jpg",
  },
  {
    id: 11,
    name: "Valérie T.",
    location: "Paris 16e",
    type: "Appartement 5 pièces",
    service: "Loi Carrez",
    rating: 5,
    date: "Septembre 2024",
    text: "Mesurage Loi Carrez très précis pour un grand appartement du 16e. Le diagnostiqueur a pris le temps de tout mesurer minutieusement. Résultat conforme à mes attentes.",
    avatar: "/img/readdy/rv11.jpg",
  },
  {
    id: 12,
    name: "Julien F.",
    location: "Massy (91)",
    type: "Appartement T3",
    service: "Pack Location",
    rating: 5,
    date: "Septembre 2024",
    text: "Pack location complet pour mon appartement à Massy. Intervention rapide, rapport clair. Mon locataire a pu signer le bail dans les délais. Excellent rapport qualité-prix.",
    avatar: "/img/readdy/rv12.jpg",
  },
];

export const reviewStats = {
  average: 4.9,
  total: 127,
  breakdown: [
    { stars: 5, count: 118, pct: 93 },
    { stars: 4, count: 7, pct: 5.5 },
    { stars: 3, count: 2, pct: 1.5 },
    { stars: 2, count: 0, pct: 0 },
    { stars: 1, count: 0, pct: 0 },
  ],
};
